import { render, staticRenderFns } from "./RoundSetting.vue?vue&type=template&id=27c37696&"
import script from "./RoundSetting.vue?vue&type=script&lang=js&"
export * from "./RoundSetting.vue?vue&type=script&lang=js&"
import style0 from "./RoundSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports